module.exports = __webpack_public_path__ + "img/cost-1@2x.56510b73.png";